<template>
  <div class="home">
    <van-cell class="actValue" title="邀约访客">
      <span>
        <a @click="goHome">来访预约</a>
      </span>
    </van-cell>

    <p class="part_title">主访客信息</p>
    <common-input
      v-model.trim="dataFrom.name"
      :err-msg="nameErrMsg"
      display="false"
      :max="20"
      name="姓名"
      placeholder="请输入姓名"
      @inputBlured="cheackName"
    />
    <common-input
      v-model.trim="dataFrom.phone"
      :err-msg="phonErrMsg"
      display="false"
      type="number"
      name="手机号"
      placeholder="请输入手机号"
      @inputBlured="cheackPhone"
      @inputChanged="cheackPhone"
    />
    <van-field v-model.trim="dataFrom.carNumber" label="来访车牌" placeholder="请输入来访车牌号" />
    <p class="part_title">来访事由及时间</p>
    <van-cell required class="actValue" title="来访事由">
      <span @click="showCause = true">{{ dataFrom.reason }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访楼层">
      <span @click="changeFloor">{{ dataFrom.floorName }}</span>
    </van-cell>
    <van-cell required class="actValue" title="来访时间">
      <span @click="showPicker = true">{{ dataFrom.visitDate }}</span>
    </van-cell>
    <van-cell required class="actValue" title="有效天数">
      <van-stepper v-model.trim="dataFrom.accessDays" min="1" :max="limitDays" />
    </van-cell>
    <van-cell required class="actValue" title="通行时效">
      <span @click="showOnce = true">{{ showOnceText }}</span>
      <!--      // dataFrom.once === undefined ? '' : (dataFrom.once ? '' : '')-->
    </van-cell>
    <ul v-if="dataFrom.retinues.length>0">
      <p class="part_title">陪同访客信息</p>
      <li v-for="(item,index) in dataFrom.retinues" :key="index" @click="onChange(index)">
        <van-swipe-cell>
          <van-cell :border="false" :title="'陪同访客'+ Number(index+1)" :value="item.name" />
          <template #right>
            <van-button square type="danger" text="删除" @click="onDel(index)" />
          </template>
        </van-swipe-cell>
      </li>
    </ul>
    <van-button class="add_btn sub_btn" type="default" @click="onAdd">添加陪同访客</van-button>
    <van-button :disabled="!clickFlag" class="sub_btn" type="info" @click="onInvite">提交邀约申请</van-button>
    <div v-show="showCause" class="piker_wrap" @click="showCause = false">
      <ul class="piker_content" @click.stop>
        <li
          v-for="(item,index) in reasonList"
          :key="index"
          :class="{active:active==index}"
          @click="changeReason(item,index)"
        >{{ item }}</li>
      </ul>

      <div class="cancel" @click="onCancel">取消</div>
    </div>
    <van-dialog v-model="addDialog" class="teamdialog" :before-close="beforeClose" title="添加陪同访客" show-cancel-button>
      <common-input
        v-model.trim="teamFrom.name"
        :err-msg="teamNameErrMsg"
        display="false"
        name="姓名"
        placeholder="请输入陪同访客姓名"
      />
      <common-input
        v-model.trim="teamFrom.phone"
        :err-msg="teamPhoneErrMsg"
        display="false"
        type="number"
        name="手机号"
        placeholder="请输入陪同访客手机号"
      />
      <van-field v-model.trim="teamFrom.carNumber" class="hasinput" label="来访车牌" placeholder="请输入来访车牌号" />
    </van-dialog>
    <van-dialog v-model="showDialog" class="new—dialog" title="温馨提示" confirm-button-text="我知道了" message-align="left">
      <div class="van-dialog__message">
        <p>系统每人每天仅支持同时生效1条访问记录，{{ visitorMsg.name }} 已登记于{{ visitorMsg.visitDate }}访问 {{ visitorMsg.beVisitCompanyName }} {{ visitorMsg.beVisitStaffName }}，当前状态:{{ visitorMsg.visitorStatusName }}</p>
        <p class="tips">请联系该访客结束（取消）上次访问后再邀约，谢谢</p>
      </div>

    </van-dialog>
    <van-popup v-model="showPicker" position="bottom" :style="{ height: '50%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :filter="filter"
        :min-date="minDate"
        :formatter="formatter"
        @confirm="timeConfirm"
        @cancel="showPicker =false"
      />
    </van-popup>
    <van-popup v-model="showOnce" position="bottom" :style="{ height: '40%' }">
      <van-picker
        title="通行时效"
        show-toolbar
        value-key="text"
        :default-index="0"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showOnce = false"
      />
    </van-popup>
  </div>
</template>

<script>
import moment from 'moment';
import commonInput from '@/components/commonInput';
import { Invite, getReasons } from '@/api/home';
import { GetStaffInfo } from '@/api/user';
export default {
  name: 'Invite',
  components: {
    commonInput
  },
  data() {
    return {
      active: 0,
      reasonList: [],
      showDialog: false,
      changeIndex: -1,
      visitorMsg: {},
      showOnce: false,
      limitDays: 30,
      clickFlag: false,
      fromHistoryInfo: {},
      dataFrom: {
        once: true,
        accessDays: 1,
        reason: '',
        visitDate: '',
        carNumber: '',
        name: '',
        phone: '',
        retinues: [],
        floorName: '',
        beVisitFloorId: ''
      },
      teamFrom: {
        name: '',
        phone: '',
        carNumber: ''
      },
      showPicker: false,
      showCause: false,
      minDate: new Date(),
      currentDate: '',
      addDialog: false,
      datetime: '',
      nameErrMsg: '', // 姓名输入提示
      phonErrMsg: '', // 手机号校验提示
      teamPhoneErrMsg: '', // 陪同访客手机号提示
      teamNameErrMsg: '', // 陪同访客姓名提示
      columns: [],
      showOnceText: ''
    };
  },
  computed: {
    dataRange() {
      let needVal = '';
      let needless = '';
      needVal = Number(Boolean(this.dataFrom.name)) + Number(Boolean(this.dataFrom.phone));
      needless = Number(Boolean(this.nameErrMsg)) + Number(Boolean(this.phonErrMsg));
      return {
        needVal,
        needless
      };
    }
  },
  watch: {
    dataRange(val) {
      if (Number(val.needVal) === 2 && Number(val.needless) === 0) {
        this.clickFlag = true;
      } else {
        this.clickFlag = false;
      }
    },
    'dataFrom.once'(val) {
      if (val === undefined) {
        this.showOnceText = this.columns[0].text;
      }
      let trueText = '';
      let falseText = '';
      this.columns.forEach(item => {
        if (item.value) {
          trueText = item.text;
        } else {
          falseText = item.text;
        }
      });
      if (val) {
        this.showOnceText = trueText;
      } else {
        this.showOnceText = falseText;
      }
    }
  },
  created() {
    this.getReasonList();
    const { inviteInfo } = this.$route.params;
    if (inviteInfo) {
      const info = JSON.parse(inviteInfo);
      const { retinues } = info;
      this.fromHistoryInfo = info;
      this.dataFrom = info;
      this.dataFrom.floorName = info.floorName;
      this.dataFrom.accessDays = 1;
      this.teamFrom = retinues;
      const data = {
        id: info.beVisitFloorId,
        parentId: info.beVisitEdificeId,
        parentName: info.beVisitEdificeName,
        name: info.beVisitFloorName
      };
      this.$store.dispatch('setFloorInfo', { data: data });
    } else {
      this.dataFrom = this.$store.state.inviteData;
      this.getStaffInfo();
    }
    this.setTime();
  },
  methods: {
    goHome() {
      this.$router.push({ name: 'home' });
      const dataFrom = {
        once: true,
        accessDays: 1,
        reason: '',
        visitDate: '',
        carNumber: '',
        name: '',
        phone: '',
        retinues: [],
        floorName: '',
        beVisitFloorId: ''
      };
      this.$store.dispatch('setFloorInfo', { data: {}});
      this.$store.dispatch('setInviteData', { data: dataFrom });
    },
    filter(type, options) {
      if (type === 'minute') {
        return options.filter(option => option % 30 === 0);
      } else {
        return options;
      }
    },
    formatter(type, value) {
      switch (type) {
        case 'year':
          value = `${value}年`;
          break;
        case 'month':
          value = `${value}月`;
          break;
        case 'day':
          value = `${value}日`;
          break;
        case 'hour':
          value = `${value}时`;
          break;
        case 'minute':
          value = `${value}分`;
          break;
      }
      return value;
    },
    getStaffInfo() {
      GetStaffInfo({}).then(res => {
        const { edifice, floor, floorId, edificeId } = res.data;
        const info = this.$store.state.floorInfo;
        if (info.id) {
          this.$store.dispatch('setFloorInfo', { data: info });
          this.dataFrom.floorName = info.parentName + info.name;
          this.dataFrom.beVisitFloorId = info.id;
        } else {
          this.dataFrom.floorName = edifice + floor;
          info.id = floorId;
          info.parentId = edificeId;
          info.parentName = edifice;
          info.name = floor;
          this.dataFrom.beVisitFloorId = floorId;
          this.$store.dispatch('setFloorInfo', { data: info });
        }
      });
    },
    // 设置默认时间为当前时间的下一个整点
    setTime() {
      const now = moment().format('HH:mm:ss');
      var num = now.indexOf(':');
      var time = Number(now.substring(0, num)) + 1;
      if (time.toString().length === 1) {
        time = '0' + time;
      }
      this.dataFrom.visitDate = moment().format('YYYY-MM-DD ') + time + ':00';
      this.currentDate = new Date(moment().format('YYYY/MM/DD ') + time + ':00'); // ios不支持YYYY_MM_DD 的new Date写法
      this.minDate = new Date(moment().format('YYYY/MM/DD HH') + ':00');
    },
    timeConfirm(val) {
      var d = new Date().getTime();
      var d1 = new Date(val).getTime();
      if (d1 < d) {
        this.$toast({
          message: '来访时间不能在当前时间之前'
        });
        return;
      }

      this.dataFrom.visitDate = moment(val).format('YYYY-MM-DD HH:mm');
      this.showPicker = false;
    },
    getReasonList() {
      const data = {};
      getReasons(data).then(res => {
        const accessTypes = Object.keys(res.data.accessTypes);
        const columns = [];
        accessTypes.forEach(item => {
          const data = { text: item, value: res.data.accessTypes[item] };
          columns.push(data);
        });
        this.columns = columns;
        this.showOnceText = this.columns[0].text;
        this.dataFrom.once = this.columns[0].value;
        this.limitDays = res.data.limitDays;
        this.reasonList = res.data.reasons;
        const { inviteInfo } = this.$route.params;
        if (inviteInfo) {
          const info = JSON.parse(inviteInfo);
          if (this.reasonList.includes(info.reason)) {
            this.dataFrom.reason = info.reason;
          } else {
            this.dataFrom.reason = this.reasonList[0];
          }
        } else {
          this.dataFrom.reason = this.dataFrom.reason || this.reasonList[0];
        }
      });
    },
    onCancel() {
      this.showCause = false;
    },
    onAdd() {
      this.addDialog = true;
      this.changeIndex = -1;
      this.teamFrom = {
        name: '',
        phone: '',
        carNumber: ''
      };
      this.teamPhoneErrMsg = '';
      this.teamNameErrMsg = '';
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        if (!this.cheackTeamName() && !this.cheackTeamPhone()) {
          if (this.changeIndex === -1) {
            this.dataFrom.retinues.push(this.teamFrom);
          } else {
            this.dataFrom.retinues[this.changeIndex] = this.teamFrom;
          }
          done();
        } else {
          done(false);
        }
      } else if (action === 'cancel') {
        done(); // 关闭
      }
    },
    onDel(index) {
      this.dataFrom.retinues.splice(index, 1);
    },
    onConfirm(e) {
      this.showOnce = false;
      this.dataFrom.once = e.value;
    },
    onInvite() {
      if (!this.clickFlag) {
        return;
      }
      this.clickFlag = false;
      Invite(this.dataFrom).then(res => {
        if (res.code === 200) {
          this.$router.push({ path: '/inviteSuc', query: { id: res.data }});
        } else if (res.code === 50001) {
          this.visitorMsg = res.data;
          this.showDialog = true;
          this.clickFlag = true;
        } else {
          this.$dialog.alert({
            title: '温馨提示',
            message: res.message,
            confirmButtonText: '我知道了'
          });
          this.clickFlag = true;
        }
      }).catch(_ => {
        this.clickFlag = true;
      });
    },
    cheackPhone() {
      let phone;
      if (this.dataFrom.phone == '') {
        phone = false;
        this.phonErrMsg = '请输入手机号';
      } else if (!(/^1[3456789]\d{9}$/.test(this.dataFrom.phone))) {
        this.phonErrMsg = '手机号格式错误，请检查';
        phone = false;
      } else {
        this.phonErrMsg = '';
        phone = true;
      }
      return phone;
    },
    cheackTeamPhone() {
      if (this.teamFrom.phone === '') {
        this.teamPhoneErrMsg = '请输入正确格式的手机号';
      } else if (!(/^1[3456789]\d{9}$/.test(this.teamFrom.phone))) {
        this.teamPhoneErrMsg = '手机号格式错误，请检查';
      } else {
        this.teamPhoneErrMsg = '';
      }
      return this.teamPhoneErrMsg;
    },
    cheackTeamName() {
      if (this.teamFrom.name == '') {
        this.teamNameErrMsg = '请输入姓名';
      } else {
        this.teamNameErrMsg = '';
      }
      return this.teamNameErrMsg;
    },
    cheackName() {
      let name;
      if (this.dataFrom.name === '') {
        name = false;
        this.nameErrMsg = '请输入姓名';
      } else {
        this.nameErrMsg = '';
        name = true;
      }
      return name;
    },
    changeReason(item, i) {
      this.active = i;
      this.dataFrom.reason = item;
      this.showCause = false;
    },
    onChange(index) {
      this.changeIndex = index;
      this.teamFrom = this.dataFrom.retinues[index];
      this.teamPhoneErrMsg = '';
      this.teamNameErrMsg = '';
      this.addDialog = true;
    },
    changeFloor() {
      this.$router.push({ name: 'changeFloor' });
      this.$store.dispatch('setInviteData', { data: this.dataFrom });
    }
  }

};
</script>

<style lang="less" scoped>
.van-cell {
  flex-wrap: wrap;
}
@import '../style/home';
</style>
